"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomInterface = exports.CustomCoder = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _abi = require("@ethersproject/abi");
var _strings = require("@ethersproject/strings");
var _bytes = require("@ethersproject/bytes");
var _bytes2 = require("@ethersproject/abi/lib/coders/bytes");
/**
 * Custom version of the string coder that returns the hex data instead when
 * the string isn't valid UTF-8.
 */
class CustomStringCoder extends _bytes2.DynamicBytesCoder {
  constructor(localName) {
    super("string", localName);
    (0, _defineProperty2.default)(this, "decoder", new TextDecoder("utf-8", {
      fatal: true
    }));
  }
  defaultValue() {
    return "";
  }
  encode(writer, value) {
    return super.encode(writer, (0, _strings.toUtf8Bytes)(value));
  }
  decode(reader) {
    let data = super.decode(reader);
    try {
      return this.decoder.decode(data);
    } catch (err) {
      data = (0, _bytes.hexlify)(data);
    }
    return data;
  }
}
class CustomCoder extends _abi.AbiCoder {
  _getCoder(param) {
    if (param.baseType === "string") {
      return new CustomStringCoder(param.name);
    } else {
      return super._getCoder(param);
    }
  }
}
exports.CustomCoder = CustomCoder;
class CustomInterface extends _abi.Interface {
  static getAbiCoder() {
    return new CustomCoder();
  }
}
exports.CustomInterface = CustomInterface;
//# sourceMappingURL=CustomCoder.js.map